(function () {

/* Object for all Static variables */
var Static = {};

Static.authURI = "/api/v2/chart/credentials";

Static.chartsURI = "/api/v2/chart/charts";

Static.getOrdersURI = "/api/v2/strategies/instances";

Static.dataURL = "https://marketdata-streamer.smarttbot.com";

Static.streamURL = "wss://marketdata-streamer.smarttbot.com/rtdata";

Static.maxResolutionDays = {
    one:               20,
    five:              20,
    ten:               40,
    fifteen:           60,
    thirty:            120,
    hour:              240,
    day:               2000,
    day_without_after: 2000
};

Static.defaultSymbolConfig = {
    type:     "papel",

    // We replaced the timezone because there is no longer DST in Brazil, and the
    // timezone definitions in trading view are static in their code, so we changed
    // to Buenos Aires which had an equivalent timezone to the one that São Paulo
    // has now (UTC-3 all year without DST).
    // timezone: "America/Sao_Paulo",
    timezone: "America/Argentina/Buenos_Aires",

    intraday_multipliers: ["1", "5", "10", "15", "30", "H"],

    minmov:     1,
    minmov2:    0,
    pricescale: 100,

    has_intraday:           true,
    has_daily:              true,
    has_weekly_and_monthly: true
};

Static.defaultWidgetConfig = {
    fullscreen:           true,
    symbol:               "WDO%",
    interval:             "15",
    container_id:         "chart-container",
    library_path:         "./bower_components/charting_library/charting_library/",
    locale:               "pt",
    enabled_features:     ["same_data_requery"],
    disabled_features:    ["study_market_minimized"],
    indicators_file_name: "custom_indicators.js",
    //timezone: "America/Sao_Paulo"
    timezone: "America/Argentina/Buenos_Aires"
};

Static.defaultChartConfig = {
    exchanges: [
        {
            value: "",
            name: "Todos os mercados"
        }
    ],
    symbolsTypes: [
        {
            value: "",
            name:  "Todos os tipos"
        }
    ],
    supported_resolutions:
        ["1", "5", "10", "15", "30", "45", "60", "D", "W", "2W", "M"],
    support_marks:            false,
    supports_timescale_marks: false,
    supports_time:            false,
};

/**
 * Main class definition. The ideal scenario would be not to save any data, but
 * we need it to control the behavior of the chart.
 *
 * @param Object credentials Used to validate the current user.
 * @param string uniqueId    Used to save and load chart
 * @param Object orderData   Order used metadata
 */
function SBDatafeed(credentials, uniqueId, overwrite, orderData) {
    // Overwrite flag
    this.overwrite = overwrite || false;

    // After market flag.
    this.afterMarket = true;

    // After market button.
    this.afterMarketToggle = null;

    // User credentials.
    this.credentials = credentials;

    // Chart id.
    this.uniqueId = uniqueId;

    // Chart code.
    this.code = "";

    // Order related data
    this.orderData = orderData || null;

    // Orders
    this.orders = [];

    // Widget instance using this datafeed.
    this.widget = null;

    // Used to control timeouts
    this.lastResetOrders     = null;

    // A hash with all symbols being observed. Used by the socket connection.
    this.subscribedSymbols = {};

    // Used to monitor all last parcial candles.
    this.partialLastCandles = {};

    // Just like parcialLastCandles, but stores committed candles.
    this.committedLastCandles = {};

    // Used as the first candle of partial renko candles.
    this.candleRenkoEndpoints = {};

    // Used as the last 'missing' candles for renko construction
    this.candleRenkoStartpoints = {};

    // Just like parcialLastRenko, but stores committed renko candles.
    this.committedLastRenkoCandles = {};

    // Socket connections for realtime updates.
    this.subscribers = {};

    // Method hard registration
    this.informInstance      = informInstance.bind(this);
    this.mountSymbol         = mountSymbol.bind(this);
    this.onReady             = onReady.bind(this);
    this.searchSymbolsByName = searchSymbolsByName.bind(this);
    this.resolveSymbol       = resolveSymbol.bind(this);
    this.getBars             = getBars.bind(this);
    this.calculateHistoryDepth = calculateHistoryDepth.bind(this);
    this.subscribeBars       = subscribeBars.bind(this);
    this.unsubscribeBars     = unsubscribeBars.bind(this);
    this.createButtons       = createButtons.bind(this);
    // Save/load chart
    this.fetchCharts         = fetchCharts.bind(this);
    this.saveChart           = saveChart.bind(this);
    this.loadChart           = loadChart.bind(this);
    // Load orders
    this.resetOrders         = resetOrders.bind(this);
    this.getOrders           = getOrders.bind(this);
    this.drawOrders          = drawOrders.bind(this);
    this.removeAllOrders     = removeAllOrders.bind(this);
}

function calculateHistoryDepth(resolution, resolutionBack, intervalBack) {
    if (resolutionBack === "D") {
        SBResolution = toSBResolution(resolution);
        const maxDays = Static.maxResolutionDays[SBResolution];
        if (intervalBack > maxDays) {
            return {
                resolutionBack: resolutionBack,
                intervalBack: maxDays,
            };
        }
    }

    return undefined;
}

/**
 * Renko related functions. The Renko chart is constructed just like the OHLC
 * chart. The OHLC candles are converted on demand to Renko bars. A lot of hacks
 * are used ensure the Renko chart will work. [HACK] tag will be used for it.
 */

/**
 * Merges an array of candles to the given input resolution
 * @param  array candles
 * @param  int   fromResolution
 * @param  int   toResolution
 * @return array
 */
function mergeCandles(candles, fromResolution, toResolution) {
    function highAcessor(candle) {
        return candle.high;
    }

    function lowAcessor(candle) {
        return candle.low;
    }

    function volumeAcessor(candle) {
        return candle.volume;
    }

    function stocksAcessor(candle) {
        return candle.stocks;
    }

    function tradesAcessor(candle) {
        return candle.trades;
    }

    var size, chunk, converted, volume, high, low, stocks, trades;

    size = toResolution / fromResolution;
    converted = [];

    while (candles.length > 0) {
        chunk = candles.splice(0, size);

        high   = Math.max.apply(null, chunk.map(highAcessor));
        low    = Math.min.apply(null, chunk.map(lowAcessor))
        volume = 0;
        trades = 0;
        stocks = 0;

        chunk
            .forEach(function (candle) {
                volume += volumeAcessor(candle);
                trades += tradesAcessor(candle);
                stocks += stocksAcessor(candle);
            });

        converted.push(buildCandle(
            chunk[0].time,
            chunk[0].open,
            high,
            low,
            chunk[chunk.length - 1].close,
            volume,
            stocks,
            trades
        ));
    }

    return converted;
}

/**
 * Builds a renko candle object.
 *
 * @param  int   time      unix milliseconds timestamp
 * @param  float open
 * @param  float close
 * @return object          the built renko candle
 */
function buildRenkoCandle(time, open, close) {
    if (close > open)
        return buildCandle(
            time, open, close, open, close, NaN, NaN, NaN, "renko");
    else
        return buildCandle(
            time, open, open, close, close, NaN, NaN, NaN, "renko");
}

/**
 * Returns the next discrete value.
 * (4.1, 0.5, true) -> (4.5)
 * (4.1, 0.5, false) -> (4.0)
 * (4.0, 0.5, true | false) -> 4.0
 *
 * @param  float value   value to be aligned
 * @param  float base    used as discrete size
 * @param  bool  alignUp direction of alignment
 * @return float         aligned value
 */
function alignValue(value, base, alignUp) {
    if (alignUp && value % base > 0)
        return value + base - value % base
    else
        return value - value % base;
}

/**
 * Rounds value to given precision
 *
 * @param  float x     input value
 * @param  float p     precision
 * @return float       rouded value
 */
function roundTo(x, p) {
    p = p || 10000
    return Math.round(x * p) / p;
}

/**
 * Returns an object with the next candle index whose absolute difference
 * between the candle close price and the input price is greater or equal to
 * the input base.
 *
 * @param  float price     reference starting price
 * @param  array candles   all candles to be analised
 * @param  int   offset    first index of the array to be compared
 * @param  float base      minimal difference
 * @param  bool  direction direction of the difference
 * @return int             index of the candle
 */
function nextDelta(price, candles, offset, base, direction) {
    var candle, i;

    for (i = offset; i < candles.length; ++i) {
        candle = candles[i];

        if (
            direction && roundTo(candle.close - price) > base ||
            !direction && roundTo(price - candle.close) > base
        )
            return i;
    }

    return NaN;
}

/**
 * Generates an array of renko candles built by interpolating the given prices.
 *
 * @param  float from initial aligned price
 * @param  float to   final price
 * @param  float base discrete interval of difference
 * @param  int   time initial time of the renko candle
 * @return array      an array with the interpolated renko candles
 */
function interpolateRenko(from, to, base, time) {
    var interpolated, amount, open, close, normalFrom, normalTo, d, i;

    from = roundTo(from)
    to = roundTo(to)

    normalFromDecimal = roundTo(from / base);
    normalToDecimal = roundTo(to / base);

    if (to > from) {
        normalFrom = Math.floor(normalFromDecimal);
        normalTo = Math.floor(normalToDecimal);

        if (normalTo === normalToDecimal) {
            normalTo -= 1
        }
    } else {
        normalFrom = Math.ceil(normalFromDecimal);
        normalTo = Math.ceil(normalToDecimal);

        if (normalTo === normalToDecimal) {
            normalTo += 1
        }
    }

    interpolated = [];
    amount = Math.abs(normalFrom - normalTo);
    d = (normalTo > normalFrom) ? 1 : -1;

    for (i = 1; i <= amount; ++i) {
        open  = roundTo(from + d * (i - 1) * base);
        close = roundTo(from + d * i * base);

        interpolated.push(
            buildRenkoCandle(time + (i - 1), open, close));
    }

    // console.log(
    //     "interpolateRenko:", from, to, moment(time).format(),
    //     normalFrom, normalTo, amount, interpolated)

    return interpolated;
}

/**
 * Convert an input array of candles to renko candles.
 *
 * @param  array candles
 * @param  float base     size of the renko candles
 * @return object         object containing:
 *     - r : array with built renko candles
 *     - fu: index of the first used candle
 *     - lu: index of the last used candle
 */
function candlesToRenko(candles, base) {
    var
        candUpIndex, candDownIndex, candle, index, direction, next, reversion,
        sequence, price, renkoCandles, firstUsedIndex, lastUsedIndex;

    if (!candles.length)
        return null;

    renkoCandles  = [];
    index         = 0;
    candle        = candles[index];

    // First we need to find the candidate indices
    candUpIndex   = nextDelta(
        alignValue(candle.close, base, false),
        candles,
        index + 1,
        2 * base,
        true);
    candDownIndex = nextDelta(
        alignValue(candle.close, base, true),
        candles,
        index + 1,
        2 * base,
        false);

    // No initial index, then no possible renko candle
    if (!candUpIndex && !candDownIndex) {
        return {
            r: [],
            fu: NaN,
            lu: NaN
        }
    }

    // Down candidate index not found or Up candidate index smaller
    else if (!candDownIndex || candUpIndex < candDownIndex) {
        index = candUpIndex;
        direction = true;
    }

    // Up candidate index not found or Down candidate index smaller
    else if (!candUpIndex || candDownIndex < candUpIndex) {
        index = candDownIndex;
        direction = false;
    }

    // Saves the first used index
    firstUsedIndex = index;

    // Defining starting interpolation point
    candle = candles[index];

    price     = alignValue(candle.close, base, !direction);
    sequence  = nextDelta(price, candles, index + 1, base, direction);
    reversion = nextDelta(price, candles, index + 1, 2 * base, !direction);

    // Populate renko candles while possible
    while (sequence || reversion) {

        // Same
        if (!reversion || sequence <= reversion) {
            next = sequence;
        }

        // Reverted direction
        else if (!sequence || reversion <= sequence) {
            next      = reversion;
            direction = !direction;
            price     = (direction) ? price + base : price - base;
        }

        // Populating renko candles
        Array.prototype.push.apply(
            renkoCandles,
            interpolateRenko(
                price,
                candles[next].close,
                base,
                candles[index].time)
            );

        index     = next;
        price     = renkoCandles[renkoCandles.length - 1].close;
        sequence  = nextDelta(price, candles, index + 1, base, direction);
        reversion = nextDelta(price, candles, index + 1, 2 * base, !direction);
    }

    // Saves the last used index
    lastUsedIndex = index;

    return {
        r:  renkoCandles,
        fu: firstUsedIndex,
        lu: lastUsedIndex
    };
}

/**
 * General utility functions. This function are defined to be used by any type
 * of chart.
 */

/**
 * Builds a candle object.
 *
 * @param  int   time      unix milliseconds timestamp
 * @param  float open
 * @param  float high
 * @param  float low
 * @param  float close
 * @param  float volume
 * @return object          the built candle
 */
function buildCandle(time, open, high, low, close, volume, stocks, trades, type) {
    return {
        time:   time,
        open:   open,
        high:   high,
        low:    low,
        close:  close,
        volume: volume,
        stocks: stocks,
        trades: trades,
        type:   type || "candle"
    };
}

/**
 * Join URI paths with a slash.
 * @param  array paths all paths
 * @return string      resultant URI
 */
function pathJoin(paths) {
    return paths.join("/");
}

/**
 * Join query arguments.
 * @param  object params all query params
 * @return string        resultant query string
 */
function queryJoin(params) {
    var query = [];

    Object.keys(params).forEach(function (param) {
        query.push(param + "=" + encodeURIComponent(params[param]));
    });

    return query.join("&");
}

/**
 * Convert resolution from TradingView format to Smarttbot format.
 *
 * @param  string resolution
 * @return string
 */
function toSBResolution(resolution) {
    switch(resolution) {
        case "1" : return "one";
        case "5" : return "five";
        case "10": return "ten";
        case "15": return "fifteen";
        case "30": return "thirty";
        case "H" : return "hour";
        default  : return "day";
    }
}

/**
 * Convert resolution to minutes.
 * @param  string resolution
 * @return int
 */
function toMinutes(resolution) {
    var parser, multiplier, unit, result, minutes;

    parser     = /([0-9]*)([HDWM]?)/;
    result     = parser.exec(resolution);
    multiplier = parseInt(result[1]);
    unit       = result[2];
    minutes    = 1;

    if (multiplier)
        minutes *= multiplier;


    switch(unit) {
        case "H":
            minutes *= 60;
            break;
        case "D":
            minutes *= 24 * 60;
            break;
        case "W":
            minutes *= 7 * 24 * 60;
            break;
        case "M":
            minutes *= 30 * 24 * 60;
            break;
    }

    return minutes;
}

/**
 * Aligns timestamp with a given time discretion.
 *
 * @param  int  time unix timestamp in milliseconds
 * @param  int  mins number of minutes
 * @param  bool up   whether the next discrete value or not
 * @return int       aligned timestamp
 */
function alignTimestamp(time, mins, up, market) {
    var ms = mins * 60 * 1000;
    var dayBeginning = moment(time).hour(0).minute(0).second(0).millisecond(0).valueOf();
    if (market === "BMF") {
        dayBeginning = moment(time).hour(9).minute(0).second(0).millisecond(0).valueOf();
    } else if (market === "BOVESPA") {
        dayBeginning = moment(time).hour(10).minute(0).second(0).millisecond(0).valueOf();
    }
    var dayTime = time - dayBeginning;
    if (up && dayTime % ms > 0) {
        return dayBeginning + dayTime - dayTime % ms + ms;
    } else {
        return dayBeginning + dayTime - dayTime % ms;
    }
}

/**
 * TradingView Datafeed related functions. This functions implements the desired
 * behavior expected by TradingView. Full explanation on TradingView Wiki.
 */

/**
 * Mounts symbol ticker information using internal data provider.
 *
 * @param  object data
 * @return object      TradingView expected symbol information
 */
function mountSymbol(data) {
    var info;

    info = $.extend({}, Static.defaultSymbolConfig, {
        name:            data.code,
        ticker:          data.code,
        description:     data.market_name + ":" + data.code,
        exchange:        data.market_name,
        listed_exchange: data.market_name,
        session:         (data.market_name == "BMF")
            ? "0900-1820"
            : "1000-1800",
        data_status:     (this.credentials.data_type == "delay")
            ? "delayed_streaming"
            : "streaming"
    });

    return info;
}

/**
 * Executed when the chart widget completed its loading proccess.
 *
 * @param  function onReadyCallback
 */
function onReady(onReadyCallback) {
    function ready() {
        this.createButtons();
        this.fetchCharts();
        this.widget.chart().onDataLoaded().subscribe(this, this.resetOrders);
    }

    if (!this.widget)
        throw "You must call 'informInstance' as soon as creating the widget.";

    this.widget.onChartReady(ready.bind(this));

    setTimeout(function () {
        onReadyCallback(Static.defaultChartConfig);
    });
}

/**
 * Executed when the user searchs for a symbol.
 * @param  string userInput
 * @param  string exchange
 * @param  string symbolType
 * @param  function onResultReadyCallback
 */
function searchSymbolsByName(
    userInput,
    exchange,
    symbolType,
    onResultReadyCallback
) {
    // Extracts symbol data for search exhibition.
    function extractSymbolData(symbol) {
        return {
            symbol:      symbol.name,
            full_name:   symbol.exchange + ":" + symbol.name,
            description: symbol.description,
            exchange:    symbol.exchange,
            ticker:      symbol.ticker,
            type:        symbol.type
        };
    }

    // Request successful
    function requestExecuted(success, data) {
        var symbols;

        symbols = data
            .map(this.mountSymbol)
            .map(extractSymbolData);

        success(symbols);
    }

    var url;

    if (userInput.length < 2)
        return;

    url = pathJoin([Static.dataURL, "data/stocks", encodeURI(userInput)])
        + "/?" + queryJoin(this.credentials);

    $.ajax(url, {
        success: requestExecuted.bind(this, onResultReadyCallback)
    });
}

/**
 * Executed when the user selects a symbol.
 *
 * @param  string   symbolName
 * @param  function onSymbolResolvedCallback
 * @param  function onResolveErrorCallback
 */
function resolveSymbol(
    symbolName,
    onSymbolResolvedCallback,
    onResolveErrorCallback
) {
    // Request successful
    function requestExecuted(symbolName, success, fail, data) {
        var iterator, found;

        // Finding the input symbol
        found = null;
        while (!found && (iterator = data.shift())) {
            if (symbolName == iterator.code || symbolName.indexOf("%") > 0)
                found = this.mountSymbol(iterator);
        }

        if (found)
            success(found);
        else
            fail("Símbolo não encontrado.");
    }

    // Request Failed
    function requestFailed() {
        onResolveErrorCallback("Falha ao procurar símbolos.");
    }

    symbolName = (symbolName.indexOf(":") >= 0) ? symbolName.split(":")[1] : symbolName;

    // Mounting URL
    var url = pathJoin([Static.dataURL, "data/stocks", encodeURI(symbolName)]) + "/?"
        + queryJoin(this.credentials);

    // Executing
    $.ajax(url, {
        success: requestExecuted.bind(
            this,
            symbolName,
            onSymbolResolvedCallback,
            onResolveErrorCallback),
        error: requestFailed
    });
}

function getNextAvailableCandlesTime(
    stockCode, lastDatetimeTimestamp, credentials, onHistoryCallback, onErrorCallback
) {
    const lastDatetime = moment.unix(lastDatetimeTimestamp)
    const searchRange  = {
        start_datetime: lastDatetime.clone().add(-5, "years").format("YYYY-MM-DDTHH:mm:ss"),
        end_datetime: lastDatetime.format("YYYY-MM-DDTHH:mm:ss"),
    };

    const url = pathJoin([
        Static.dataURL,
        "data/candles",
        "day",
        stockCode])
        + "/?"
        + queryJoin(credentials)
        + "&"
        + queryJoin(searchRange);

    const requestExecuted = (data) => {
        const last_candle = data[0]
        const meta = {
            version: 2,
            // noData: !last_candle,
            noData: true,
        };
        if (last_candle) {
            meta.nextTime = moment(last_candle.datetime).add(1, "day").valueOf()/1000
        }
        onHistoryCallback([], meta);
    }

    $.ajax(url, {
        success: requestExecuted,
        error: () => {
            onErrorCallback("Falha ao recuperar dados.");
        },
    });
}

/**
 * Searchs for historical candles.
 *
 * @param  object   symbolInfo        all metadata from the requested symbol
 * @param  string   resolution        size of the candles
 * @param  int      from              unix timestamp in seconds
 * @param  int      to                likewise
 * @param  function onHistoryCallback successful callback
 * @param  function onErrorCallback   fail callback
 * @param  boolean firstDataRequest   whether this is a first request of symbol
 */
function getBars(
    symbolInfo,
    resolution,
    from,
    to,
    onHistoryCallback,
    onErrorCallback,
    firstDataRequest
) {
    var SBResolution, searchRange, symbolName, url;

    SBResolution = toSBResolution(resolution);
    symbolName   = symbolInfo.ticker;

    // [HACK] Limiting the number of days to search bars
    if ((to - from) / (60 * 60 * 24) > Static.maxResolutionDays[SBResolution])
        from = to - Static.maxResolutionDays[SBResolution] * 24 * 60 * 60;

    const requestExecuted = (data) => {
        var candles, meta, renkoSize, renkoCandles;

        candles = data
            .map(
                function (candle) {
                    return buildCandle(
                        moment(candle.datetime).valueOf(),
                        candle.open,
                        candle.high,
                        candle.low,
                        candle.close,
                        candle.financial_volume,
                        candle.number_of_stocks,
                        candle.number_of_trades
                    );
            })
            // The candles come in inverse order
            .reverse();

        if (candles.length === 0) {
            getNextAvailableCandlesTime(
                symbolName, from, this.credentials, onHistoryCallback, onErrorCallback
            );
            return;
        }

        meta = {
            version: 2,
            noData: false,
            // [HACK] Since we cannot know what is exactly the end time of the
            // previous series, we assume it to be the current start time.
            // nextTime: from - 1
        };

        // Saving the last candle of the series
        if (!(symbolName in this.committedLastCandles) && candles.length > 0)
            this.committedLastCandles[symbolName] = candles[candles.length-1];

        // [HACK] Detecting if the renko chart is enabled. If true, conversion
        // is started. Note that 'getRenkoSize' was injected in TradingView
        // code.
        renkoSize = this.widget.chart().getRenkoSize();

        if (renkoSize) {
            // Adding first candle of candle series to construct renko
            if (
                this.candleRenkoStartpoints[symbolName] &&
                this.candleRenkoStartpoints[symbolName].time >
                    candles[candles.length-1].time
            ) {
                candles.push(this.candleRenkoStartpoints[symbolName]);
            }

            // [HACK] If chart resolution is not the same as the given resolution
            // we must merge candles before creating renko candles.
            if (this.widget.chart().resolution() != resolution) {
                candles = mergeCandles(
                    candles,
                    toMinutes(resolution),
                    toMinutes(this.widget.chart().resolution())
                );
            }

            renkoCandles = candlesToRenko(candles, renkoSize);


            // [HACK] A lot of candles were dropped by renko conversion. It is
            // needed to refetch them on the next request, so we replace the end
            // search time to the time of the first renko candle.
            if (renkoCandles.r.length > 0) {
                meta.nextTime = candles[renkoCandles.fu].time;
                this.candleRenkoStartpoints[symbolName] = candles[renkoCandles.fu];

                // Saving the last renko candle of the series
                if (!(symbolName in this.committedLastRenkoCandles))
                    this.committedLastRenkoCandles[symbolName] =
                        renkoCandles.r[renkoCandles.r.length - 1];

                // Saveing the last candle renko endpoint
                if (!(symbolName in this.candleRenkoEndpoints))
                    this.candleRenkoEndpoints[symbolName] =
                        candles[renkoCandles.lu];
            }

            // Finally, setting candles to renko candles
            candles = renkoCandles.r;
        }
        onHistoryCallback(candles, meta);
    }

    searchRange  = {
        start_datetime: moment.unix(from).format("YYYY-MM-DDTHH:mm:ss"),
        end_datetime:   moment.unix(to).format("YYYY-MM-DDTHH:mm:ss")
    };

    url = pathJoin([
        Static.dataURL,
        "data/candles",
        SBResolution,
        symbolName])
        + "/?"
        + queryJoin(this.credentials)
        + "&"
        + queryJoin(searchRange);

    // Series state resetting
    if (firstDataRequest) {
        delete this.committedLastCandles[symbolName];
        delete this.partialLastCandles[symbolName];
        delete this.committedLastRenkoCandles[symbolName];
        delete this.candleRenkoEndpoints[symbolName];
        delete this.candleRenkoStartpoints[symbolName];
    }

    $.ajax(url, {
        success: requestExecuted,
        error: () => {
            onErrorCallback("Falha ao recuperar dados.");
        },
    });
}

/**
 * Handles realtime updates.
 *
 * @param  object   symbolInfo         all metadata from the requested symbol
 * @param  string   resolution         size of the candles
 * @param  function onRealtimeCallback called on realtime updates
 * @param  function subscriberUID      id of each subscriber
 */
function subscribeBars(
    symbolInfo,
    resolution,
    onRealtimeCallback,
    subscriberUID
) {
    function onMessage(event) {
        var data, date, time, timestamp, raw, candle, committed,
            committedCandle, partialCandle;

        data = JSON.parse(event.data);

        // No relevant data.
        if (data.type != 0 && data.type != 1)
            return;

        raw = data.candles[SBResolution];

        if (!raw.last_identifier || raw.last_identifier === "NaN") {
            console.error("Invalid candle in message", raw);
            return;
        }

        date = moment(raw.last_date, "YYYYMMDD");
        time = moment(raw.last_time, "HHmmss");

        date
            .hour(time.hour())
            .minute(time.minute())
            .second(time.second());

        timestamp = alignTimestamp(date.utc().valueOf(), mins, false);
        candle    = buildCandle(
            timestamp,
            raw.open,
            raw.max,
            raw.min,
            raw.close,
            raw.volume,
            raw.quantity,
            raw.trades
        );

        committed       = false;
        partialCandle   = this.partialLastCandles[symbolName];
        committedCandle = this.committedLastCandles[symbolName];

        // Committing last candle
        if (partialCandle && candle.time > partialCandle.time) {
            this.committedLastCandles[symbolName] = committedCandle =
                this.partialLastCandles[symbolName];

            committed = true;
        }

        // Updating last parcial candle
        this.partialLastCandles[symbolName] = partialCandle = candle;

        var renkoSize, commitRenko, committedRenkoCandle, endpoint,
            renkoCandles;

        // [HACK] Detecting if Renko is enabled
        renkoSize            = this.widget.chart().getRenkoSize();
        committedRenkoCandle = this.committedLastRenkoCandles[symbolName];
        endpoint             = this.candleRenkoEndpoints[symbolName];

        if (renkoSize && committedRenkoCandle) {
            // Whether the renko candles are committable
            commitRenko = (
                committed &&
                (
                committedCandle.close - committedRenkoCandle.high > renkoSize ||
                committedRenkoCandle.low - committedCandle.close > renkoSize
                )
            );

            // Only updates the view
            if (!commitRenko) {

                // Partial increasing renko candle
                if (partialCandle.close - committedRenkoCandle.high > 0)
                    onRealtimeCallback(buildRenkoCandle(
                        endpoint.time + mins * 60 * 1000,
                        committedRenkoCandle.high,
                        partialCandle.close
                    ));

                // Partial decreasing renko candle
                else if (committedRenkoCandle.low - partialCandle.close > 0)
                    onRealtimeCallback(buildRenkoCandle(
                        endpoint.time + mins * 60 * 1000,
                        committedRenkoCandle.low,
                        partialCandle.close
                    ));

                // Oscillating renko candle
                else
                    onRealtimeCallback(buildCandle(
                        endpoint.time + mins * 60 * 1000,
                        partialCandle.close,
                        partialCandle.close,
                        partialCandle.close,
                        partialCandle.close,
                        NaN,
                        NaN,
                        NaN
                    ));
            }

            // Commits the renko candles
            else {
                var o;

                if (committedCandle.close - committedRenkoCandle.high > 0)
                    o = committedRenkoCandle.high;
                else
                    o = committedRenkoCandle.low;

                // Generating renko candles
                renkoCandles = interpolateRenko(
                    o,
                    committedCandle.close,
                    renkoSize,
                    endpoint.time + mins * 60 * 1000
                );

                // Committing last renko candle
                this.committedLastRenkoCandles[symbolName]
                    = renkoCandles[renkoCandles.length - 1];

                // Updating candle renko endpoint
                this.candleRenkoEndpoints[symbolName] = committedCandle;

                // Exposing renko candles
                renkoCandles.forEach(onRealtimeCallback);
            }
        } else onRealtimeCallback(candle);
    }

    function onOpen() {
        socket.send(JSON.stringify({
            credentials: this.credentials,
            codes:       [symbolInfo.ticker],

            compress:          false,
            binary:            false,
            price_change_only: false,

            output_type: {
                type: "candles",
                periodicities: [SBResolution]
            }
        }));
    }

    var socket, SBResolution, mins, symbolName;

    SBResolution = toSBResolution(resolution);
    mins         = toMinutes(resolution);
    socket       = new WebSocket(Static.streamURL);
    symbolName   = symbolInfo.ticker;

    socket.onmessage = onMessage.bind(this);
    socket.onopen    = onOpen.bind(this);

    this.subscribers[subscriberUID] = socket;
}

/**
 * Destroy a socket associated with given id.
 *
 * @param  string subscriberUID
 */
function unsubscribeBars(subscriberUID) {
    this.subscribers[subscriberUID].close();
    delete this.subscribers[subscriberUID];
}

/**
 * Informs SBDatafeed of the TradingView widget instance
 */
function informInstance(instance) {
    if (this.widget)
        throw "You must call this 'informInstance' only once.";

    this.widget = instance;
}

/**
 * Order managemente functions implemented here.
 */

/**
 * Loads all orders from the given robot..
 *
 * @param  int from
 * @param  int to
 */
function getOrders(from, to) {
    var url, query;

    query = {
        initial_datetime: moment.unix(from).format("YYYY-MM-DDTHH:mm:ss"),
        final_datetime: moment.unix(to).format("YYYY-MM-DDTHH:mm:ss"),
        include_external_orders: "1",
        return_attributes: [
            "datetime", "market_name", "order_type", "average_nominal_price",
            "gross_profit", "number_of_stocks",
        ],
    };

    url = `${Static.getOrdersURI}/${this.orderData.instanceID}/orders?${queryJoin(query)}`;
    $.ajax(url, {
        type:    "GET",
        success: this.drawOrders.bind(this)});
}

/**
 * Plots the executed orders
 *
 * @param  array data each order
 */
function drawOrders(data) {
    function groupOrders(orders, resolution) {
        var groups, order, last;

        groups = [];
        groups.push([]);
        last = null

        while (order = orders.shift()) {
            order.timestamp = alignTimestamp(
                moment(order.datetime).valueOf(),
                resolution,
                false,
                order.market_name
            ) / 1000;

            if (last && order.timestamp != last.timestamp)
                groups.push([]);

            groups[groups.length - 1].push(order);

            last = order;
        }

        return groups;
    }

    function summaryGroups(groups) {
        var group, order, first, last, summaries, last, sum, amount, summary;

        summaries = [];

        while (group = groups.shift()) {
            summary = {};

            if (!group.length)
                continue;

            first = group[0];
            amount = group.length;
            sum = 0;
            last = (amount > 1) ? group[group.length-1] : null;

            summary = {
                first: {
                    direction: first.order_type == "0" ? "buy" : "sell",
                    price:     parseFloat(first.average_nominal_price),
                    timestamp: first.timestamp,
                    color:     "#AAA"
                },
                tooltip: "",
                total:   0
            };

            if (first.gross_profit && first.gross_profit > 0)
                summary.first.color = "#0F0";
            else if (first.gross_profit && first.gross_profit < 0)
                summary.first.color = "#F00";

            if (last) {
                summary.last = {
                    direction: last.order_type == "0" ? "buy" : "sell",
                    price:     parseFloat(last.average_nominal_price),
                    timestamp: last.timestamp,
                    color:     "#AAA"
                }

                if (last.gross_profit && last.gross_profit > 0)
                    summary.last.color = "#0F0";
                else if (last.gross_profit && last.gross_profit < 0)
                    summary.last.color = "#F00";
            }

            while (order = group.shift()) {
                if (order.gross_profit)
                    sum += parseFloat(order.gross_profit);

                if (order.order_type == "0")
                    summary.tooltip += "Compra: ";
                else
                    summary.tooltip += "Venda: ";

                summary.tooltip +=
                    order.number_of_stocks
                    + " x "
                    + parseFloat(order.average_nominal_price)
                    + "\n";
            }

            summary.tooltip += amount + " ordens: R$" + sum;
            summary.total = sum;

            summaries.push(summary);
        }

        return summaries;
    }

    var summaries, summary, order, text;

    this.removeAllOrders();

    summaries = summaryGroups(
        groupOrders(data.orders, toMinutes(this.widget.chart().resolution()))
    );

    while (summary = summaries.shift()) {
        order = this.widget.chart().createExecutionShape({disableUndo: true});

        if (!summary.last && summary.total != 0) {
            text = summary.first.price +"(R$" + summary.total + ")";
        } else {
            text = summary.first.price
        }

        order
            .setText(text)
            .setTooltip(summary.tooltip)
            .setPrice(summary.first.price)
            .setDirection(summary.first.direction)
            .setArrowColor(summary.first.color)
            .setTime(summary.first.timestamp);

        this.orders.push(order);

        if (summary.last) {
            order = this.widget.chart().createExecutionShape({disableUndo: true});

            if (summary.total != 0) {
                text = summary.last.price +"(R$" + summary.total + ")";
            } else {
                text = summary.last.price;
            }


            order
                .setText(text)
                .setTooltip(summary.tooltip)
                .setPrice(summary.last.price)
                .setDirection(summary.last.direction)
                .setArrowColor(summary.last.color)
                .setTime(summary.last.timestamp);

            this.orders.push(order);
        }
    }
}

/**
 * Remove all orders from the chart.
 */
function removeAllOrders() {
    var order;

    while (order = this.orders.shift())
        order.remove();

    this.orders = [];
}

/**
 * Resets orders.
 */
 function resetOrders() {
    var range, resolution;

    if (this.lastResetOrders) {
        clearTimeout(this.lastResetOrders);
        this.lastResetOrders = null;
    }

    if (!this || !this.orderData) return;

    range = this.widget.chart().getActiveRange();
    resolution = toMinutes(this.widget.chart().resolution()) * 60 * 1000;

    // Forming candle orders must be plotted as well
    this.getOrders(range.from, range.to + resolution);

    this.lastResetOrders = setTimeout(this.resetOrders, 60000);
 }

/**
 * Save/Load related functions implemented here.
 */

/**
 * Saves the current chart.
 */
function saveChart() {
    function save(data) {
        var hasCode = (this.code != "");

        if ( hasCode && this.last_data == JSON.stringify(data) ) {
            return
        }

        this.last_data = JSON.stringify(data)

        $.ajax({
            type: hasCode ? "PUT" : "POST",
            url:  hasCode
                ? pathJoin([Static.chartsURI, this.code])
                : Static.chartsURI,
            data: JSON.stringify({
                name: this.uniqueId,
                data: data,
                start_datetime: 0,
                end_datetime: 0
            }),
            contentType: "application/json; charset=utf-8",
            success: function (data) {
                if ( data.code ) {
                    this.code = data.code;
                }
            }.bind(this)
        });
    }

    if (!this) return;

    this.widget.save(save.bind(this));

    setTimeout(this.saveChart, 30000);
}

/**
 * Fetchs all saved charts
 */
function fetchCharts() {
    function onCharts(data) {
        if (data && data.code) {
            this.code = data.code;
            this.loadChart(data);
        } else {
            this.saveChart();
        }
    }

    $.ajax({
        type:    "GET",
        url:     pathJoin([Static.chartsURI, this.uniqueId]),
        success: onCharts.bind(this)
    });
}

/**
 * Loads a previously saved chart.
 *
 * @param  string code return code from api
 */
function loadChart(chart_data) {
    function load(data) {
        data = data.data
        if ( typeof(data) == typeof("") ) {
            data = JSON.parse(data);
        }

        // Forces the timezone of the chart.
        //data.charts[0].timezone = "America/Sao_Paulo";
        data.charts[0].timezone = "America/Argentina/Buenos_Aires";

        // [HACK] Overwritting loaded chart
        if (this.overwrite) {
            var symbol = this.widget.chart().symbol().split(":")[1];
            var resolution = this.widget.chart().resolution();
            data.charts[0].panes[0].sources[0].state.symbol = symbol;
            data.charts[0].panes[0].sources[0].state.shortName = symbol;
            data.charts[0].panes[0].sources[0].state.interval = resolution;
        }

        this.widget.load(data);
        this.saveChart();
    }

    if ( chart_data ) {
        load.bind(this)(chart_data)
        return
    }

    $.ajax({
        type:    "GET",
        url:     pathJoin([Static.chartsURI, this.code]),
        success: load.bind(this)
    });
}

/**
 * Creates useful UI buttons.
 */
function createButtons() {
    var saveSVG = [
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17" ',
            'width="17" height="17">',
            '<path style="fill: #7d7d7d" d="m 4.6081443,14.996573 ',
                '7.7910187,0 0,-3.895509 -7.7910187,0 0,3.895509 z m ',
                '9.0891157,0 1.299314,0 0,-9.0903311 c 0,-0.094983 ',
                '-0.0341,-0.2289327 -0.09986,-0.3896727 -0.06697,-0.1668286 ',
                '-0.137597,-0.2861659 -0.204571,-0.351923 L ',
                '11.842661,2.310294 C 11.770811,2.243319 11.657567,2.176344 ',
                '11.495609,2.1105868 11.333651,2.0436118 11.200919,2.0058623 ',
                '11.101065,2.0058623 v 4.224295 c 0,0.2703353 ',
                '-0.0962,0.499268 -0.286166,0.6892335 -0.189965,0.1899654 ',
                '-0.418898,0.2849481 -0.689234,0.2849481 H 4.279358 c ',
                '-0.271553,0 -0.499268,-0.094983 -0.6892334,-0.2849481 C ',
                '3.3989414,6.7294253 3.3088296,6.5004926 3.3088296,6.2301573 ',
                'V 2.0058623 H 2.0058617 V 14.999009 h 1.3029679 v -4.219425 ',
                'c 0,-0.271553 0.090111,-0.504138 0.281295,-0.689233 C ',
                '3.78009,9.8991672 4.007805,9.8041862 4.279358,9.8041862 h ',
                '8.44372 c 0.270335,0 0.504139,0.09498 0.689233,0.2861648 ',
                '0.189966,0.185095 0.284949,0.41768 0.284949,0.689233 v ',
                '4.219425 z m -3.89551,-9.4191174 0,-3.2440247 c 0,-0.090112 ',
                '-0.032879,-0.165611 -0.094983,-0.227715 C ',
                '9.6397927,2.0387415 9.5642933,2.0058624 9.4790524,2.0058624 ',
                'H 7.5282537 c -0.085241,0 -0.1619577,0.032879 ',
                '-0.2289327,0.099854 -0.065757,0.062104 -0.094983,0.1376031 ',
                '-0.094983,0.227715 V 5.577456 c 0,0.09133 0.029226,0.1668286 ',
                '0.094983,0.2289327 0.066974,0.066975 0.1436919,0.099854 ',
                '0.2289327,0.099854 h 1.9507987 c 0.085241,0 ',
                '0.16074,-0.032879 0.227715,-0.099854 0.062104,-0.062104 ',
                '0.094983,-0.1376031 0.094983,-0.2289327 z m ',
                '6.492921,0.3287863 0,9.4130281 c 0,0.271554 -0.09498,0.50414 ',
                '-0.284948,0.690452 -0.186312,0.189965 -0.418897,0.284948 ',
                '-0.690451,0.284948 H 1.6807286 c -0.2703353,0 ',
                '-0.499268,-0.09499 -0.6892334,-0.284948 C 0.80152979,15.82341 ',
                '0.70532936,15.590824 0.70532936,15.31927 V 1.6807292 c ',
                '0,-0.2703354 0.0962004,-0.4992681 0.28616584,-0.68923362 ',
                '0.1899654,-0.1899653 0.4188981,-0.28616575 ',
                '0.6892334,-0.28616575 h 9.4191184 c 0.270336,0 ',
                '0.565026,0.071846 0.893813,0.20457805 0.323914,0.13882102 ',
                '0.580856,0.29956092 0.77082,0.48587312 l 2.83974,2.8446103 c ',
                '0.189966,0.1899655 0.351923,0.4469059 0.489526,0.7708213 ',
                '0.13395,0.3226976 0.199707,0.6222584 0.199707,0.8938116 z"/>',
        '</svg>'
    ];

    this.widget.createButton()
        .attr("title", "Salvar")
        .append($(saveSVG.join("")))
        .on("click", this.saveChart.bind(this));
/*
    this.afterMarketToggle = $("<span>Com After Market</span>")[0];

    this.widget.createButton()
        .attr("title", "After Market")
        .append(this.afterMarketToggle)
        .on("click", function () {
            this.afterMarket = !this.afterMarket;
            if (this.afterMarket){
                this.afterMarketToggle.innerHTML = "Com After Market";
            } else {
                this.afterMarketToggle.innerHTML = "Sem After Market";
            }

            // Refreshing symbol
            var symbol = this.widget.chart().symbol();
            console.log(symbol);
            this.widget.chart().setSymbol(symbol);
        }.bind(this));
*/

}

// Globals
SBDatafeed.Static = Static;

// Utils
SBDatafeed.pathJoin             = pathJoin;
SBDatafeed.queryJoin            = queryJoin;
SBDatafeed.fromTVtoSBResolution = toSBResolution;
SBDatafeed.fromTVtoMinutes      = toMinutes;
SBDatafeed.alignTimestamp       = alignTimestamp;

// Exposing constructor
window.SBDatafeed = SBDatafeed;
})();
